const Numeric = (($) => {

    const NAME = 'numeric';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        allowDecimalPadding: true,
        currencySymbol: '',
        digitGroupSeparator: '',
        minimumValue: '-9999999999999.99',
        maximumValue: '9999999999999.99',
        negativeBracketsTypeOnBlur: null,
        suffixText: '',
        modifyValueOnWheel: false,
        unformatOnSubmit: true
    };
    const Selector = {
        NUMERIC: `.js-${NAME}`
    };

    class Numeric {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this._autoNumeric = new AutoNumeric(element, config);
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
        }

        clear() {
            return this._autoNumeric.clear(true);
        }

        getNumber() {
            return this._autoNumeric.getNumber();
        }

        set(data) {
            return this._autoNumeric.set(data);
        }

        reformat() {
            return this._autoNumeric.reformat();
        }
        unformat() {
            return this._autoNumeric.unformat();
        }

        reset() {
            setTimeout(() => this._autoNumeric.set($(this._element).prop('defaultValue')), 100);
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Numeric(this, config);
                    $this.data(DATA_KEY, data); //.autoNumeric('init', config);
                }
            });
        }
    }

    $(() => Numeric._jQueryInterface.call($(Selector.NUMERIC)));
    $(document).ajaxStop(() => Numeric._jQueryInterface.call($(Selector.NUMERIC)));

    $.fn[NAME] = Numeric._jQueryInterface;
    $.fn[NAME].Constructor = Numeric;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Numeric._jQueryInterface;
    }

    return Numeric;
})(jQuery);